/* Rebuy Dynamic Bundle widget #313356 ("Get the set & save") enhancements:
   trims .00 from prices, drops the color from product titles, and keeps unchecked items' images
   visible (grayed) so they can be re-added. */
(function () {
  /* Only ever run once, even if this script is loaded twice */
  if (window.__hwBundleScript) return;
  window.__hwBundleScript = true;

  var ID = 'rebuy-widget-313356';
  var PRICE_RE = /(\$\d[\d,]*)\.00(?!\d)/g;
  var OPTS = { childList: true, subtree: true, characterData: true };
  var cache = {};
  var current = null;
  var widgetObs = null;

  /* Grayed-out style for unchecked product images */
  var style = document.createElement('style');
  style.textContent =
    '#' + ID + ' .hw-ghost{opacity:.45;filter:grayscale(100%);cursor:pointer}' +
    '#' + ID + ' .hw-ghost:hover,#' + ID + ' .hw-ghost:focus{opacity:.65}';
  document.head.appendChild(style);

  function pid(el) {
    var m = el.className.match(/product-id-(\d+)/);
    return m && m[1];
  }

  /* Remove Rebuy tracking attributes so ghosts never count as impressions/clicks */
  function stripData(el) {
    [el].concat([].slice.call(el.querySelectorAll('*'))).forEach(function (n) {
      [].slice.call(n.attributes).forEach(function (a) {
        if (a.name.indexOf('data-') === 0) n.removeAttribute(a.name);
      });
    });
  }

  /* $46.00 -> $46, keeps $37.50 as is */
  function trimPrices(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.indexOf('.00') > -1) n.nodeValue = n.nodeValue.replace(PRICE_RE, '$1');
    }
  }

  /* "Cloud Cotton Pant - Black" -> "Cloud Cotton Pant" (color still shows in the dropdown) */
  function trimTitles(root) {
    root.querySelectorAll('.rebuy-product-title a').forEach(function (a) {
      var walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = walker.nextNode())) {
        var i = n.nodeValue.lastIndexOf(' - ');
        if (i > 0) n.nodeValue = n.nodeValue.slice(0, i);
      }
    });
  }

  /* Keep unchecked product images visible, grayed out; tap or press Enter to re-add */
  function ghostImages(w) {
    var row = w.querySelector('.rebuy-bundle__images');
    if (!row) return;
    row.querySelectorAll('.hw-ghost').forEach(function (g) {
      g.remove();
    });

    row.querySelectorAll('.rebuy-bundle__image').forEach(function (el) {
      var id = pid(el);
      if (id && !cache[id]) cache[id] = el.cloneNode(true);
    });

    var blocks = w.querySelectorAll('.rebuy-bundle__items .rebuy-product-block');
    var prev = null;
    blocks.forEach(function (b) {
      var id = pid(b);
      var real = id && row.querySelector('.rebuy-bundle__image.product-id-' + id);
      if (real) {
        prev = real;
        return;
      }
      if (!id || !cache[id]) return;

      var g = cache[id].cloneNode(true);
      stripData(g);
      g.classList.add('hw-ghost');
      g.querySelectorAll('a').forEach(function (a) {
        a.removeAttribute('href');
      });

      var img = g.querySelector('img');
      var name = img && img.getAttribute('alt');
      g.setAttribute('role', 'button');
      g.setAttribute('tabindex', '0');
      g.setAttribute('aria-label', name ? 'Add ' + name + ' back to bundle' : 'Add item back to bundle');

      function readd(e) {
        e.preventDefault();
        var cb = b.querySelector('.rebuy-checkbox');
        if (!cb) return;
        cb.click();
        if (e.type === 'keydown')
          setTimeout(function () {
            cb.focus();
          }, 0);
      }
      g.addEventListener('click', readd);
      g.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') readd(e);
      });

      if (prev && prev.nextSibling) row.insertBefore(g, prev.nextSibling);
      else if (prev) row.appendChild(g);
      else row.insertBefore(g, row.firstChild);
      prev = g;
    });
  }

  /* Attach to a widget; re-run whenever Rebuy re-renders it */
  function bind(w) {
    if (widgetObs) widgetObs.disconnect();
    current = w;
    widgetObs = new MutationObserver(run);
    function run() {
      widgetObs.disconnect(); /* ignore our own changes */
      try {
        ghostImages(w);
        trimPrices(w);
        trimTitles(w);
      } finally {
        widgetObs.observe(w, OPTS);
      }
    }
    run();
  }

  /* Color swatches swap in a new widget without a page load (product-swatches.js -> Rebuy.reinit()):
     re-attach when that happens, so this observer intentionally has no timeout */
  function check() {
    var w = document.getElementById(ID);
    if (w && w !== current && w.querySelector('.rebuy-bundle')) bind(w);
  }

  check();
  new MutationObserver(check).observe(document.documentElement, { childList: true, subtree: true });
})();
